import { render, staticRenderFns } from "./RecuperarSenhaForm.vue?vue&type=template&id=7349bc24"
import script from "./RecuperarSenhaForm.vue?vue&type=script&lang=js"
export * from "./RecuperarSenhaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_cache-loader@4.1.0_webpack@4.47.0__css-load_2ea687c826b7d973d8594d3aaaaddc42/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports